import React from 'react';
import Spinner from './Spinner';

const OverlaySpinner = ({...props}) => (
  <Spinner
    fullWidth
    fullHeight
    style={{
      position: 'absolute',
      zIndex: 4,
      backgroundColor: '#ffffff7f',
    }}
    {...props}
  />
);

export default OverlaySpinner;
